import { Component, OnInit, Optional, Injector } from '@angular/core';
import { UtilitiesService } from '../../../../services/utilities.service';
import DynamicFormDTO from '../../dtos/DynamicFormDTO';
import { InputFieldType } from '../../enums/InputFieldType';
import { AiAssistantService } from 'src/app/services/ai-assistant/ai-assistant.service';
import { ActivatedRoute } from '@angular/router';
import { getEntityByName } from 'src/app/services/ai-assistant/entities-dictionary';

@Component({
  selector: 'app-base-dynamic-form',
  templateUrl: './base-dynamic-form.component.html'
})
/**
 * Base Dynamic Form Component
 */
export class BaseDynamicFormComponent implements OnInit {
  title: string = "";
  isLoading: boolean = true;
  fields:  Array<DynamicFormDTO> = [];
  sidebarFields:  Array<DynamicFormDTO> = [];
  layout: string = 'full-screen';
  entityType: string;
  hideEnabledField: boolean = false;
  viewRoute: string;
  protected utilitiesService?: UtilitiesService;
  protected aiAssistantService?: AiAssistantService;
  protected route2?: ActivatedRoute;
  
  constructor(@Optional() protected injector?: Injector) {
    if (injector) {
      this.utilitiesService = injector.get(UtilitiesService);
      this.aiAssistantService = injector.get(AiAssistantService);
      this.route2 = injector.get(ActivatedRoute);
    }
  }

  /**
   * Base Dynamic Form Component Initialization
   */
  ngOnInit() {}

  async passContextToIaAssistant(entity: string, fieldTypesToFilter: InputFieldType[], entityContext: string) {
    if (this.aiAssistantService) {
      const isEdit = !!this.route2?.snapshot.paramMap.get('id');
      const result = await this.aiAssistantService.getMetadataForContext(this.fields, entity, fieldTypesToFilter, entityContext, isEdit);

      if (result) {
        const context ={
          type: result.metadata.type,
          output: result.output,
          metadata: result.metadata
        }

        await this.aiAssistantService.openChat();
        await this.aiAssistantService.sendMessage(context);
      }
    }
  }

  /**
   * Enhanced AI assistant integration using entities dictionary
   * Automatically determines field types and uses comprehensive entity context
   */
  async passEntityContextToIaAssistant(entityKey: string) {
    console.log('entityKey', entityKey);
    if (this.aiAssistantService) {
      const entityInfo = getEntityByName(entityKey);
      console.log('entityInfo', entityInfo);
      if (!entityInfo) {
        console.warn(`Entity ${entityKey} not found in dictionary. Falling back to basic integration.`);
        return;
      }

      
      // Automatically determine field types based on common text input types
      const textFieldTypes = [
        InputFieldType.TextInput,
        InputFieldType.InputTextArea
      ];

      const isEdit = !!this.route2?.snapshot.paramMap.get('id');
      const result = await this.aiAssistantService.getMetadataForContext(
        this.fields, 
        entityKey, 
        textFieldTypes, 
        entityInfo.contextPrompt, 
        isEdit,
        // ['MAX_CHARACTER_COUNT', 'OPTIONS_COUNT', 'OUTPUT_JSON', 'BANNED_WORDS']
        entityInfo.promptKeys
      );

      if (result) {
        result.formContext = this;

        const context = {
          entity: entityKey,
          type: result.metadata.type,
          output: result.output,
          metadata: result.metadata
        }

        await this.aiAssistantService.openChat();
        await this.aiAssistantService.sendMessage(context);
      }
    }
  }
}